export default "__VITE_ASSET__CMtSYn0J__"